
























import {Component, Mixins, Prop} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';

@Component({
  components: {
    EditDialog,
    SelectionList,
  },
})
export default class MeasurementsEditDialog extends Mixins(EditDialogMixin) {
  @Prop()
  nodeId!: number;

  @Prop()
  measurements!: any[];
}
